import Vuetify from 'vuetify';
import colors from 'vuetify/es5/util/colors';
import 'vuetify/dist/vuetify.min.css';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

const mainColor = colors.blue; //blue for normal

export default {
  install(Vue) {
    /**
     * These elements were added by accident when they don't exist in the
     * version of Vuetify we're using. This config let's them continue to be
     * added to the DOM as-is without being rendered, while also not logging
     * a console error about the unknown custom element
     */
    Vue.config.ignoredElements = [
      'v-col',
      'v-row',
      'v-list-item',
      'v-list-item-title',
      'v-banner',
      'v-span',
    ];
    Vue.use(Vuetify, {
      iconfont: 'md',
      theme: {
        primary: mainColor.darken2,
        secondary: mainColor.base,
        accent: mainColor.lighten2,
        error: colors.red.lighten1,
        info: colors.blue.accent2,
        success: colors.green.base,
        warning: colors.orange.base,
        sphereBlue1: '#00538d',
      },
      icons: {},
    });
  },
};
